import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "children", "borderRadius", "borderStartStartRadius", "borderStartEndRadius", "borderEndEndRadius", "borderEndStartRadius"];
import { getBackgroundColorToken, getBadgeStyleOverrides } from './Badge.helpers';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useBadgeContext } from './BadgeProvider';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledBadge = styled.span.withConfig({
  displayName: "Badge__StyledBadge",
  componentId: "pddxvz-0"
})(({
  $cssStyles,
  $styleOverrides,
  $use,
  theme
}) => Object.assign({}, $cssStyles, {
  textAlign: 'center'
}, $use === 'count' || $use === 'dot' ? Object.assign({
  display: 'inline-block',
  backgroundColor: theme.color['fill-accent-magenta-default'],
  border: `${theme.space['25']} solid ${theme.color['border-core-on-fill-default']}`,
  pointerEvents: 'none',
  verticalAlign: 'baseline'
}, $use === 'count' && {
  fontFamily: theme.typography['heading-25'].fontFamily,
  fontWeight: theme.typography['heading-25'].fontWeight,
  color: theme.color['text-core-on-fill-default'],
  paddingBlock: `${theme.space['0']}`,
  paddingInline: `${theme.space['100']}`,
  // no tokens for the below properties
  fontSize: '11px',
  borderStartStartRadius: '500px',
  borderStartEndRadius: '500px',
  borderEndEndRadius: '500px',
  borderEndStartRadius: '500px',
  lineHeight: '19px',
  minBlockSize: '21px',
  minInlineSize: '21px'
}, $use === 'dot' && {
  borderStartStartRadius: '100%',
  borderStartEndRadius: '100%',
  borderEndEndRadius: '100%',
  borderEndStartRadius: '100%',
  height: theme.space['250'],
  textIndent: '-1000rem',
  inlineSize: theme.space['250']
}, {
  boxShadow: `${theme.space['0']} ${theme.space['0']} ${theme.space['0']} ${theme.space['25']} ${theme.color['border-core-on-fill-default']}`
}) : {
  display: 'inline-flex',
  fontFamily: theme.typography['heading-25'].fontFamily,
  fontWeight: theme.typography['heading-25'].fontWeight,
  textTransform: 'uppercase',
  verticalAlign: 'inherit',
  hyphens: 'manual',
  borderStartStartRadius: theme.borderRadius['100'],
  borderStartEndRadius: theme.borderRadius['100'],
  borderEndEndRadius: theme.borderRadius['100'],
  borderEndStartRadius: theme.borderRadius['100'],
  minHeight: theme.space['500'],
  backgroundColor: theme.color[getBackgroundColorToken($use)],
  color: theme.color[$use === 'koala' ? 'text-core-default' : 'text-core-on-fill-default'],
  paddingBlock: `${theme.space['0']}`,
  paddingInline: `${theme.space['200']}`,
  lineHeight: theme.space['500'],
  // no tokens for the below properties
  fontSize: '10px'
}, $styleOverrides));
export const Badge = _ref => {
  let {
      use = 'free',
      children,
      borderRadius,
      borderStartStartRadius,
      borderStartEndRadius,
      borderEndEndRadius,
      borderEndStartRadius
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const theme = useTheme();
  const badgeContext = useBadgeContext();
  const badgeStyleOverrides = getBadgeStyleOverrides({
    use,
    theme,
    borderRadius,
    borderStartStartRadius,
    borderStartEndRadius,
    borderEndStartRadius,
    borderEndEndRadius,
    badgeContext
  });
  return /*#__PURE__*/_jsx(StyledBadge, Object.assign({
    $cssStyles: cssStyles,
    $styleOverrides: badgeStyleOverrides,
    $use: use
  }, domProps, {
    children: /*#__PURE__*/_jsx("span", {
      children: children
    })
  }));
};